import PropTypes from 'prop-types';
import Image from 'components/image';

const VideoSource = {};

VideoSource.propTypes = {
  src: PropTypes.string.isRequired,
  previewImage: PropTypes.exact(Image.propTypes).isRequired,
};

export default VideoSource;
